var render = function (_h,_vm) {var _c=_vm._c;return _c('svg',{attrs:{"xmlns":"http://www.w3.org/2000/svg","width":"12.638","height":"22.891","viewBox":"0 0 12.638 22.891"}},[_c('path',{attrs:{"id":"label","d":"M179,0h12.638L181.476,11.761l10.162,11.129H179Z","transform":"translate(-179)","fill":"#b6d6f9"}})])}
var staticRenderFns = []

export { render, staticRenderFns }